import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import ApexCharts from 'apexcharts';

const W95Graph = ({ state, fullscreenGraphs, setFullscreenGraphs }) => {
    const [zoomRange, setZoomRange] = useState(null);

    const commonOptions = {
        chart: {
            id: "W95Graph",
            type: "area",
            height: '100%',
            zoom: {
                enabled: true,
                type: "xy",
                autoScaleYaxis: false,
                allowMouseWheelZoom: false,
            },
            toolbar: {  // Move toolbar configuration here
                autoSelected: "zoom",
                tools: {
                    download: true,
                    selection: true,
                    zoom: true,
                    zoomin: true,
                    zoomout: true,
                    pan: true,
                    reset: true,
                    customIcons: [{
                        icon: '<i class="fa fa-expand"></i>',
                        index: 0,
                        title: 'Fullscreen',
                        class: 'custom-icon',
                        click: function (chart, options, e) {
                            setFullscreenGraphs(!fullscreenGraphs);
                        }
                    }]
                },
            },
            events: {
                zoomed: function (chartContext, { xaxis }) {
                    console.log("zoomed", xaxis)
                    setZoomRange({ min: xaxis.min, max: xaxis.max });
                },
                beforeResetZoom: function (chartContext, { xaxis }) {
                    ApexCharts.exec("W95Graph", "updateOptions", {
                        xaxis: { min: undefined, max: undefined },
                        yaxis: { min: undefined, max: undefined },
                    }, false, true);
                },
            },
        },
        dataLabels: {
            enabled: false,
        },
        markers: {
            size: 0,
        },
        stroke: {
            curve: 'stepline',
            width: 2
        },
        colors: ['#483F5E'],
        fill: {
            type: 'gradient',
            gradient: {
                shadeIntensity: 1,
                inverseColors: false,
                opacityFrom: 0.5,
                opacityTo: 0,
                stops: [0, 90, 100]
            },
        },
        yaxis: {
            min: 0,
            max: 100,
            title: {
                text: 'W95 Tank Setpoint (%)',
                style: {
                    fontSize: '11px',
                    fontWeight: 400,
                    fontFamily: 'Helvetica, Arial, sans-serif',
                }
            },
        },
        xaxis: {
            type: 'datetime',
            labels: {
                datetimeUTC: false,
                format: 'dd/MM/yyyy HH:mm',
                style: {
                    fontSize: '11px'
                },
            },
            tooltip: {
                formatter: function (val) {
                    return new Date(val).toLocaleString();
                }
            }
        },
        tooltip: {
            enabled: true,
            followCursor: true,
            intersect: false,
            shared: true,
            custom: undefined,
            fixed: {
                enabled: true,
                position: 'topLeft',
                offsetX: 10,
                offsetY: 10,
            },
            x: {
                format: 'dd MMM yyyy HH:mm'
            },
            marker: {
                show: true,
            },
            onDatasetHover: {
                highlightDataSeries: true,
            },
        },
    };

    return (
        <ReactApexChart
            options={{
                ...commonOptions,
                xaxis: {
                    ...commonOptions.xaxis,
                    ...(zoomRange && { min: zoomRange.min, max: zoomRange.max }),
                },
            }}
            series={state.series}
            type="area"
            height="100%"
            width="100%"
        />
    );
};

export default W95Graph;